/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReorderPlanTasksRequestDto
 */
export interface ReorderPlanTasksRequestDto {
    /**
     * Task ids for this plan, in their new order
     * @type {Array<string>}
     * @memberof ReorderPlanTasksRequestDto
     */
    orderedTaskIds: Array<string>;
}

/**
 * Check if a given object implements the ReorderPlanTasksRequestDto interface.
 */
export function instanceOfReorderPlanTasksRequestDto(value: object): value is ReorderPlanTasksRequestDto {
    if (!('orderedTaskIds' in value) || value['orderedTaskIds'] === undefined) return false;
    return true;
}

export function ReorderPlanTasksRequestDtoFromJSON(json: any): ReorderPlanTasksRequestDto {
    return ReorderPlanTasksRequestDtoFromJSONTyped(json, false);
}

export function ReorderPlanTasksRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderPlanTasksRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'orderedTaskIds': json['orderedTaskIds'],
    };
}

export function ReorderPlanTasksRequestDtoToJSON(json: any): ReorderPlanTasksRequestDto {
    return ReorderPlanTasksRequestDtoToJSONTyped(json, false);
}

export function ReorderPlanTasksRequestDtoToJSONTyped(value?: ReorderPlanTasksRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderedTaskIds': value['orderedTaskIds'],
    };
}

